import React from 'react'
import { withIcon } from '../../withIcon'

function ShareAndroidSolidIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M14.2276 9.18194C14.7067 9.84285 15.4849 10.2727 16.3636 10.2727C17.8197 10.2727 19 9.09239 19 7.63636C19 6.18034 17.8197 5 16.3636 5C14.9076 5 13.7273 6.18034 13.7273 7.63636C13.7273 7.88898 13.7628 8.13329 13.8291 8.36459L9.77239 10.4544C9.29334 9.79351 8.51505 9.36364 7.63636 9.36364C6.18034 9.36364 5 10.544 5 12C5 13.456 6.18034 14.6364 7.63636 14.6364C8.51505 14.6364 9.29334 14.2065 9.77239 13.5456L13.8291 15.6354C13.7628 15.8667 13.7273 16.111 13.7273 16.3636C13.7273 17.8197 14.9076 19 16.3636 19C17.8197 19 19 17.8197 19 16.3636C19 14.9076 17.8197 13.7273 16.3636 13.7273C15.4849 13.7273 14.7067 14.1571 14.2276 14.8181L10.1709 12.7282C10.2372 12.4969 10.2727 12.2526 10.2727 12C10.2727 11.7474 10.2372 11.5031 10.1709 11.2718L14.2276 9.18194Z" fill={color}/>
    </svg>
  )
}

export default withIcon(ShareAndroidSolidIcon)
